import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParentButtonComponent from './ParentButtonComponent';
import LocalizedNavLink from '../router/LocalizedNavLink';

class LinkButtonComponent extends Component {
    render() {
        const { target, id, to, title, color, cssClass, text, onClick, tabIndex, external } =
            this.props;
        // Lien hors routeur (autre application du domaine) : navigation pleine page
        const destination = external ? { href: to } : { to };
        return (
            <ParentButtonComponent
                tag={external ? 'a' : LocalizedNavLink}
                color={color}
                cssClass={cssClass}
                attr={{
                    ...destination,
                    title,
                    target,
                    id,
                    onClick,
                    tabIndex
                }}>
                {text}
            </ParentButtonComponent>
        );
    }
}

LinkButtonComponent.propTypes = {
    text: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    cssClass: PropTypes.string,
    to: PropTypes.string.isRequired,
    title: PropTypes.string,
    id: PropTypes.string,
    target: PropTypes.string,
    onClick: PropTypes.func,
    external: PropTypes.bool
};

export default LinkButtonComponent;



// WEBPACK FOOTER //
// ./src/components/button/LinkButtonComponent.js